import React from 'react';
import { makeStyles, withStyles, Box, Container, Grid, Tabs } from '@material-ui/core';
import MuiTab from '@material-ui/core/Tab';
import {
  BackNavAdmin,
  CurationTitle,
  CurationTable,
  CurantionCardsStatus,
  CurationMenusTable,
  CurationCard,
  Loading,
  SkeletonTable,
  EmptyState,
  CurationFilter,
  ClassificationFilter,
  Search
} from '../../components';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../../hooks';
import config from '../../config';
import ListIcon from '@material-ui/icons/List';
import { ReactComponent as IdeaIcon } from '../../assets/imgs/ideiaPurple.svg';
import { curationIcon } from '../../assets/imgs';
import { useCurationController } from './hooks/useCurationController';
import { curationActions } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(4),
  },
}));

const Tab = withStyles({
  wrapper: {
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'lowercase',
  }
})(MuiTab);

function CurationIdeasMatPage(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { ideasStepsFlux } = useSelector(state => state.domains);
  const { loading, filters, ideas, paging } = useSelector((state) => state.curation);
  const { businessUnit } = useSelector(state => state.businessUnitProps);
  const {
    paging: {sort: challengeSort, filter: challengeFilter}
  } = useSelector(state => state.challenge);
  const {
    selectedTab,
    stepsSelected,
    challengeSelected,
    occupationAreaSelected,
    setSelectedTab,
    searchIdea,
    handleChangePage,
    handleChangeRowsPerPage
  } = useCurationController();

  const businesUnitSelected = businessUnit.filter(item => item.checked && item.value !=='SELECT_ALL').map(item => item.value) ?? [];

  useEffect(() => {
    dispatch(curationActions.getStepFluxIdeas({
      dateSort: filters.dateSort,
      statusCode: [],
      stepsIdeas: ideasStepsFlux.map(item => item._id),
      challenges: [],
      occupationAreas: [],
      businessUnits: businesUnitSelected,
      page: paging.page,
      limit: paging.limit,
      sort: paging.sort,
    }));

    dispatch(curationActions.getChallenges(1, challengeSort, challengeFilter, 100));
  }, []);

  useEffect(() => {
    if (ideasStepsFlux) {
      const ideasStepsFluxFiltered = ideasStepsFlux.map(item => ({
        label: item.name,
        value: item._id,
        checked: true
      }));

      const selectAllOptions = {
        label: t('selecionar_todos'),
        value: 'SELECT_ALL',
        checked: true,
      };

      dispatch(curationActions.loadAllSteps([selectAllOptions, ...ideasStepsFluxFiltered]));
    }
  }, [ideasStepsFlux, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(curationActions.clearText());
      dispatch(curationActions.clearCurationChallengesFilter());
      dispatch(curationActions.clearCurationStepsFilter());
      dispatch(curationActions.clearCurationPaging());
    };
  }, []);

  return (
    <>
      <BackNavAdmin title={t('curadoria')} />
      <Container maxWidth="lg" className={classes.root}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Tabs
              indicatorColor="primary"
              textColor="primary"
              centered
              value={selectedTab}
              onChange={(_e, value) => setSelectedTab(value)} 
            >
              <Tab value="LISTING" label={t('listagem_de_ideias')} />
            </Tabs>
          </Grid>
          <Grid item xs={12}>
            <CurationTitle
              title={t('lista_de_ideias')}
              icon={<ListIcon color="primary" />}
              info={t('na_listagem_e_possivel_visualizar_todas_as_ideias_filtrando_as_por_status_e_por_nome_ou_desafio')}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box display="flex" alignItems="center" justifyContent="flex-start">
                <CurationFilter
                  selectedTab={selectedTab}
                  stepsSelected={stepsSelected}
                  challengeSelected={challengeSelected}
                  occupationAreaSelected={occupationAreaSelected}
                />
                <ClassificationFilter
                  selectedTab={selectedTab}
                  stepsSelected={stepsSelected}
                  challengeSelected={challengeSelected}
                  occupationAreaSelected={occupationAreaSelected}
                />
              </Box>
              <Search
                query={searchIdea}
                placeholder={t('pesquise_por_nome_da_ideia_ou_desafio')}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            {loading ? (
              <SkeletonTable cols={6} />
            ) : selectedTab === 'LISTING' && (
              <>
                {ideas.length > 0 ? (
                  <CurationTable
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                ) : (
                  <Box paddingTop="2rem">
                    <EmptyState
                      icon={curationIcon}
                      description={t('ainda_nao_ha_ideias_por_aqui')}
                    />
                  </Box>
                )}
              </>             
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export { CurationIdeasMatPage };
